import { ENTITY_TYPES } from "../../domain/constants/entityTypes";
import { createEntitySyncHandler } from "./handlers/createEntitySyncHandler";

export const createSyncHandlerRegistry = ({ localDataAccess, remoteDataAccess }) => ({
  [ENTITY_TYPES.ORGANIZATION]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.organizations,
    remoteRepository: remoteDataAccess.repositories.organizations,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.VESSEL]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.vessels,
    remoteRepository: remoteDataAccess.repositories.vessels,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.VESSEL_PARTICULARS]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.vesselParticulars,
    remoteRepository: remoteDataAccess.repositories.vesselParticulars,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.TANK]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.tanks,
    remoteRepository: remoteDataAccess.repositories.tanks,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.VOYAGE]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.voyages,
    remoteRepository: remoteDataAccess.repositories.voyages,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.TRIP]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.trips,
    remoteRepository: remoteDataAccess.repositories.trips,
    getScope: (syncOperation, entity) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: entity.voyageId,
      tripId: syncOperation.tripId ?? entity.id,
    }),
  }),
  [ENTITY_TYPES.TRIP_CARGO]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.tripCargo,
    remoteRepository: remoteDataAccess.repositories.tripCargo,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
  [ENTITY_TYPES.AUDIT_ENTRY]: createEntitySyncHandler({
    localRepository: localDataAccess.repositories.auditEntries,
    remoteRepository: remoteDataAccess.repositories.auditEntries,
    getScope: (syncOperation) => ({
      organizationId: syncOperation.organizationId,
      vesselId: syncOperation.vesselId,
      voyageId: syncOperation.voyageId,
      tripId: syncOperation.tripId,
    }),
  }),
});
